import React from "react";
import PropTypes from "prop-types";
import { useLocation } from "react-router-dom";
import "../styles/PromptLoader.css"; // Import the CSS file with media queries

const PromptLoader = ({ loaderType }) => {
  const location = useLocation();

  // Determine appropriate class names
  const outerClassName = location.pathname.includes("aiassistant")
    ? "aiassistant-outer prompt-loader-outer"
    : "dataset-outer prompt-loader-outer";
  const innerClassName = location.pathname.includes("aiassistant")
    ? "prompt-loader-inner"
    : "dataset-inner prompt-loader-inner";

  return (
    <div className={outerClassName}>
      <div className={innerClassName}>
        <svg
          version="1.1"
          id="L9"
          xmlns="http://www.w3.org/2000/svg"
          xmlnsXlink="http://www.w3.org/1999/xlink"
          x="0px"
          y="0px"
          viewBox="0 0 100 100"
          enableBackground="new 0 0 0 0"
          xmlSpace="preserve"
          width="80px"
          height="80px"
        >
          <path
            fill="#0053ed"
            d="M73,50c0-12.7-10.3-23-23-23S27,37.3,27,50 M30.9,50c0-10.5,8.5-19.1,19.1-19.1S69.1,39.5,69.1,50"
          >
            <animateTransform
              attributeName="transform"
              attributeType="XML"
              type="rotate"
              dur="1s"
              from="0 50 50"
              to="360 50 50"
              repeatCount="indefinite"
            />
          </path>
        </svg>
      </div>
    </div>
  );
};

PromptLoader.propTypes = {
  loaderType: PropTypes.oneOf(["dataconsole", "aiassistent"]).isRequired,
};

export default PromptLoader;
